(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[900],{

/***/ 3601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ BreadCrumb_BreadCrumb; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
;// CONCATENATED MODULE: ./src/assets/svg/breadcrumb_arrow.svg
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.735073 8.99938C0.924127 8.99938 1.11306 8.9236 1.2568 8.77149L4.78616 5.04303C5.071 4.7426 5.071 4.25676 4.78616 3.95597L1.2568 0.22732C0.970702 -0.07508 0.505042 -0.0767 0.21688 0.22354C-0.0711648 0.523612 -0.0728838 1.01234 0.213334 1.31438L3.22816 4.4994L0.213334 7.68443C-0.0728838 7.98684 -0.0711648 8.4752 0.21688 8.77545C0.360277 8.92486 0.547729 8.99938 0.735073 8.99938Z",
  fill: "#969696"
});

function SvgBreadcrumbArrow({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 5,
    height: 9,
    viewBox: "0 0 5 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

/* harmony default export */ var breadcrumb_arrow = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNSIgaGVpZ2h0PSI5IiB2aWV3Qm94PSIwIDAgNSA5IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTAuNzM1MDczIDguOTk5MzhDMC45MjQxMjcgOC45OTkzOCAxLjExMzA2IDguOTIzNiAxLjI1NjggOC43NzE0OUw0Ljc4NjE2IDUuMDQzMDNDNS4wNzEgNC43NDI2IDUuMDcxIDQuMjU2NzYgNC43ODYxNiAzLjk1NTk3TDEuMjU2OCAwLjIyNzMyQzAuOTcwNzAyIC0wLjA3NTA4IDAuNTA1MDQyIC0wLjA3NjcgMC4yMTY4OCAwLjIyMzU0Qy0wLjA3MTE2NDggMC41MjM2MTIgLTAuMDcyODgzOCAxLjAxMjM0IDAuMjEzMzM0IDEuMzE0MzhMMy4yMjgxNiA0LjQ5OTRMMC4yMTMzMzQgNy42ODQ0M0MtMC4wNzI4ODM4IDcuOTg2ODQgLTAuMDcxMTY0OCA4LjQ3NTIgMC4yMTY4OCA4Ljc3NTQ1QzAuMzYwMjc3IDguOTI0ODYgMC41NDc3MjkgOC45OTkzOCAwLjczNTA3MyA4Ljk5OTM4WiIgZmlsbD0iIzk2OTY5NiIvPgo8L3N2Zz4K");

// EXTERNAL MODULE: ./src/hooks/index.ts + 3 modules
var hooks = __webpack_require__(88619);
// EXTERNAL MODULE: ./src/components/Link.tsx
var Link = __webpack_require__(3570);
// EXTERNAL MODULE: ./src/constants/theme.ts
var theme = __webpack_require__(84229);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/BreadCrumb/BreadCrumb.tsx









function BreadCrumb({
  breadCrumbs
}) {
  const siteName = (0,hooks/* useSettingItem */.qT)('WEBSITE_NAME');
  const breadCrumbList = [];

  if (siteName) {
    breadCrumbList.push({
      label: siteName,
      url: '/'
    });
  }

  if (breadCrumbs) {
    breadCrumbList.push(...breadCrumbs);
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    children: (breadCrumbList !== null && breadCrumbList !== void 0 ? breadCrumbList : []).map((item, index) => /*#__PURE__*/(0,jsx_runtime.jsxs)(Inner, {
      children: [breadCrumbList.length === index + 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)(Label, {
        children: item.label
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
        to: item.url,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Label, {
          children: item.label
        })
      }), !(breadCrumbList.length === index + 1) && /*#__PURE__*/(0,jsx_runtime.jsx)(SvgBreadcrumbArrow, {})]
    }, index))
  });
}

const Component = styled_components_browser_esm["default"].ul.withConfig({
  displayName: "BreadCrumb__Component",
  componentId: "sc-16duxws-0"
})(["margin-bottom:3px;padding-bottom:3px;white-space:nowrap;overflow:auto;display:flex;align-items:center;margin-top:15px;svg{margin:0 9px;}&::-webkit-scrollbar{-webkit-appearance:none;height:1px;}&::-webkit-scrollbar-thumb{position:absolute;top:0;border-radius:4px;background-color:", ";}"], theme/* colors.grayLighter */.O9.grayLighter);
const Inner = styled_components_browser_esm["default"].li.withConfig({
  displayName: "BreadCrumb__Inner",
  componentId: "sc-16duxws-1"
})(["display:flex;align-items:center;"]);
const Label = styled_components_browser_esm["default"].div.withConfig({
  displayName: "BreadCrumb__Label",
  componentId: "sc-16duxws-2"
})(["font-style:normal;font-weight:500;font-size:10px;line-height:18px;color:#7e7e7e;"]);
/* harmony default export */ var BreadCrumb_BreadCrumb = (BreadCrumb);
;// CONCATENATED MODULE: ./src/components/BreadCrumb/index.ts


/***/ }),

/***/ 40532:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ getCurrentAliasPage; },
/* harmony export */   "Q": function() { return /* binding */ convertActivePath; }
/* harmony export */ });
/* harmony import */ var _utils_common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29116);

const getCurrentAliasPage = path => {
  return (0,_utils_common__WEBPACK_IMPORTED_MODULE_0__/* .getAliasString */ .Jz)(path).split('/').slice(-1).join('');
};
const convertActivePath = path => {
  return path === 'blog' ? '' : path.split('/').slice(-1).join('');
};

/***/ }),

/***/ 34340:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _404; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@tager/web-components/dist/web-components.esm.js
var web_components_esm = __webpack_require__(63394);
// EXTERNAL MODULE: ./src/components/Layout/index.ts
var Layout = __webpack_require__(41880);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/use-intl/dist/production/index.js
var production = __webpack_require__(1617);
// EXTERNAL MODULE: ./src/components/ContentContainer.tsx
var ContentContainer = __webpack_require__(64283);
// EXTERNAL MODULE: ./src/components/Link.tsx
var Link = __webpack_require__(3570);
// EXTERNAL MODULE: ./src/constants/theme.ts
var theme = __webpack_require__(84229);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/modules/NotFound/NotFound.tsx









function NotFound() {
  const t = (0,production/* useTranslations */.T_)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(ContentContainer/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Inner, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextError, {
          children: "404"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextPageNotFound, {
          children: t('errors.404_title')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
          to: "/",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonLink, {
            children: t('errors.go_to_home')
          })
        })]
      })
    })
  });
}

/* harmony default export */ var NotFound_NotFound = (NotFound);
const Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "NotFound__Component",
  componentId: "sc-19kmbfl-0"
})(["height:100%;display:flex;align-items:center;"]);
const Inner = styled_components_browser_esm["default"].div.withConfig({
  displayName: "NotFound__Inner",
  componentId: "sc-19kmbfl-1"
})(["text-align:center;padding:20px 0 10px 0;"]);
const TextError = styled_components_browser_esm["default"].h1.withConfig({
  displayName: "NotFound__TextError",
  componentId: "sc-19kmbfl-2"
})(["font-size:44px;margin:0;"]);
const TextPageNotFound = styled_components_browser_esm["default"].h1.withConfig({
  displayName: "NotFound__TextPageNotFound",
  componentId: "sc-19kmbfl-3"
})(["font-size:36px;margin:0 0 30px;"]);
const ButtonLink = styled_components_browser_esm["default"].button.withConfig({
  displayName: "NotFound__ButtonLink",
  componentId: "sc-19kmbfl-4"
})(["border:1px solid ", ";color:", ";font-weight:600;border-radius:5px;width:230px;line-height:38px;&:hover{background:", ";color:", ";}"], theme/* colors.primary */.O9.primary, theme/* colors.primary */.O9.primary, theme/* colors.primary */.O9.primary, theme/* colors.white */.O9.white);
;// CONCATENATED MODULE: ./src/modules/NotFound/index.ts

;// CONCATENATED MODULE: ./src/pages/404.tsx






function NotFoundPage() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(web_components_esm/* Page */.T3, {
    title: "Page not found",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(NotFound_NotFound, {})
    })
  });
}

/* harmony default export */ var _404 = (NotFoundPage);

/***/ }),

/***/ 35635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _sentry_node__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24403);
/* harmony import */ var next_error__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12918);
/* harmony import */ var _tager_web_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63394);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);






function ErrorPage({
  statusCode,
  title,
  isInitProps,
  errorId,
  err
}) {
  if (!isInitProps && !errorId && err) {
    // getInitialProps is not called in case of
    // https://github.com/zeit/next.js/issues/8592. As a workaround, we pass
    // err via _app.js so it can be captured
    errorId = _sentry_node__WEBPACK_IMPORTED_MODULE_4__/* .captureException */ .Tb(err);
  }

  const errorCode = statusCode !== null && statusCode !== void 0 ? statusCode : 500;
  const errorName = err !== null && err !== void 0 && err.name ? err.name.replace(/\.$/, '') : title !== null && title !== void 0 ? title : 'JavaScript Error';
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_tager_web_components__WEBPACK_IMPORTED_MODULE_2__/* .Page */ .T3, {
    title: "An error occurred",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_tager_web_components__WEBPACK_IMPORTED_MODULE_2__/* .ErrorModule */ .TW, {
      errorCode: errorCode,
      errorName: errorName,
      errorId: errorId
    })
  });
}

ErrorPage.getInitialProps = async pageContext => {
  const {
    res,
    err,
    asPath
  } = pageContext;
  const errorInitialProps = await next_error__WEBPACK_IMPORTED_MODULE_1__["default"].getInitialProps(pageContext); // Workaround for https://github.com/zeit/next.js/issues/8592, mark when
  // getInitialProps has run

  errorInitialProps.isInitProps = true;

  if (res) {
    // Running on the server, the response object is available.
    //
    // Next.js will pass an err on the server if a page's `getInitialProps`
    // threw or returned a Promise that rejected
    if (res.statusCode === 404) {
      // Opinionated: do not record an exception in Sentry for 404
      return {
        statusCode: 404
      };
    }

    if (err) {
      errorInitialProps.errorId = _sentry_node__WEBPACK_IMPORTED_MODULE_4__/* .captureException */ .Tb(err);
      return errorInitialProps;
    }
  } else {
    // Running on the client (browser).
    //
    // Next.js will provide an err if:
    //
    //  - a page's `getInitialProps` threw or returned a Promise that rejected
    //  - an exception was thrown somewhere in the React lifecycle (render,
    //    componentDidMount, etc) that was caught by Next.js's React Error
    //    Boundary. Read more about what types of exceptions are caught by Error
    //    Boundaries: https://reactjs.org/docs/error-boundaries.html
    if (err) {
      errorInitialProps.errorId = _sentry_node__WEBPACK_IMPORTED_MODULE_4__/* .captureException */ .Tb(err);
      return errorInitialProps;
    }
  } // If this point is reached, getInitialProps was called without any
  // information about what the error might be. This is unexpected and may
  // indicate a bug introduced in Next.js, so record it in Sentry


  errorInitialProps.errorId = _sentry_node__WEBPACK_IMPORTED_MODULE_4__/* .captureException */ .Tb(new Error(`_error.js getInitialProps missing data at path: ${asPath}`));
  return errorInitialProps;
};

/* harmony default export */ __webpack_exports__["default"] = (ErrorPage);

/***/ }),

/***/ 82296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _post_; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@tager/web-components/dist/web-components.esm.js
var web_components_esm = __webpack_require__(63394);
// EXTERNAL MODULE: ./src/utils/thunks.ts
var thunks = __webpack_require__(26625);
// EXTERNAL MODULE: ./src/modules/Blog/components/Top/components/helpers.ts
var helpers = __webpack_require__(40532);
// EXTERNAL MODULE: ./src/utils/common.ts
var common = __webpack_require__(29116);
// EXTERNAL MODULE: ./src/store/reducers/tager/blog.ts
var blog = __webpack_require__(44272);
// EXTERNAL MODULE: ./src/pages/_error.tsx
var _error = __webpack_require__(35635);
// EXTERNAL MODULE: ./src/components/Layout/index.ts
var Layout = __webpack_require__(41880);
// EXTERNAL MODULE: ./src/pages/404.tsx + 2 modules
var _404 = __webpack_require__(34340);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./src/components/ContentContainer.tsx
var ContentContainer = __webpack_require__(64283);
// EXTERNAL MODULE: ./node_modules/use-intl/dist/production/index.js
var production = __webpack_require__(1617);
// EXTERNAL MODULE: ./src/components/BreadCrumb/index.ts + 2 modules
var BreadCrumb = __webpack_require__(3601);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/modules/Post/components/Top.tsx






const Top = ({
  urlAlias,
  pageName
}) => {
  const t = (0,production/* useTranslations */.T_)();
  const breadCrumbList = [{
    label: t('blog.title'),
    url: '/blog'
  }, {
    label: pageName,
    url: urlAlias
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(BreadCrumb/* default */.Z, {
      breadCrumbs: breadCrumbList
    })
  });
};

/* harmony default export */ var components_Top = (Top);
const Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Top__Component",
  componentId: "sc-1nasjwd-0"
})([""]);
// EXTERNAL MODULE: ./src/constants/theme.ts
var theme = __webpack_require__(84229);
// EXTERNAL MODULE: ./node_modules/@tager/web-core/dist/web-core.esm.js + 6 modules
var web_core_esm = __webpack_require__(61055);
// EXTERNAL MODULE: ./src/components/Button/index.ts
var Button = __webpack_require__(91533);
;// CONCATENATED MODULE: ./src/assets/svg/social/twitter-share.svg
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref = /*#__PURE__*/react.createElement("rect", {
  width: 112.197,
  height: 112.197,
  rx: 20,
  ry: 20,
  fill: "#2BA5EF"
});

var _ref2 = /*#__PURE__*/react.createElement("g", {
  transform: "matrix(0.7,0,0,0.7,16.829699707031253,16.829399871826176)"
}, /*#__PURE__*/react.createElement("circle", {
  cx: 56.099,
  cy: 56.099,
  r: 56.099,
  fill: "#2BA5EF"
}), /*#__PURE__*/react.createElement("path", {
  d: "M90.461,40.316c-2.404,1.066-4.99,1.787-7.702,2.109c2.769-1.659,4.894-4.284,5.897-7.417    c-2.591,1.537-5.462,2.652-8.515,3.253c-2.446-2.605-5.931-4.233-9.79-4.233c-7.404,0-13.409,6.005-13.409,13.409    c0,1.051,0.119,2.074,0.349,3.056c-11.144-0.559-21.025-5.897-27.639-14.012c-1.154,1.98-1.816,4.285-1.816,6.742    c0,4.651,2.369,8.757,5.965,11.161c-2.197-0.069-4.266-0.672-6.073-1.679c-0.001,0.057-0.001,0.114-0.001,0.17    c0,6.497,4.624,11.916,10.757,13.147c-1.124,0.308-2.311,0.471-3.532,0.471c-0.866,0-1.705-0.083-2.523-0.239    c1.706,5.326,6.657,9.203,12.526,9.312c-4.59,3.597-10.371,5.74-16.655,5.74c-1.08,0-2.15-0.063-3.197-0.188    c5.931,3.806,12.981,6.025,20.553,6.025c24.664,0,38.152-20.432,38.152-38.153c0-0.581-0.013-1.16-0.039-1.734    C86.391,45.366,88.664,43.005,90.461,40.316L90.461,40.316z",
  fill: "#FFF"
}));

function SvgTwitterShare({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 112.197 112.197",
    xmlSpace: "preserve",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}

/* harmony default export */ var twitter_share = ("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciCiAgICAgdmVyc2lvbj0iMS4xIiB3aWR0aD0iNTEyIiBoZWlnaHQ9IjUxMiIgeD0iMCIgeT0iMCIgdmlld0JveD0iMCAwIDExMi4xOTcgMTEyLjE5NyIKICAgICB4bWw6c3BhY2U9InByZXNlcnZlIj4KICA8cmVjdCB3aWR0aD0iMTEyLjE5NyIgaGVpZ2h0PSIxMTIuMTk3IiByeD0iMjAiIHJ5PSIyMCIgZmlsbD0iIzJCQTVFRiIvPgogIDxnIHRyYW5zZm9ybT0ibWF0cml4KDAuNywwLDAsMC43LDE2LjgyOTY5OTcwNzAzMTI1MywxNi44MjkzOTk4NzE4MjYxNzYpIj4KCTxjaXJjbGUgY3g9IjU2LjA5OSIgY3k9IjU2LjA5OSIgcj0iNTYuMDk5IiBmaWxsPSIjMkJBNUVGIi8+CiAgICA8cGF0aAogICAgICBkPSJNOTAuNDYxLDQwLjMxNmMtMi40MDQsMS4wNjYtNC45OSwxLjc4Ny03LjcwMiwyLjEwOWMyLjc2OS0xLjY1OSw0Ljg5NC00LjI4NCw1Ljg5Ny03LjQxNyAgICBjLTIuNTkxLDEuNTM3LTUuNDYyLDIuNjUyLTguNTE1LDMuMjUzYy0yLjQ0Ni0yLjYwNS01LjkzMS00LjIzMy05Ljc5LTQuMjMzYy03LjQwNCwwLTEzLjQwOSw2LjAwNS0xMy40MDksMTMuNDA5ICAgIGMwLDEuMDUxLDAuMTE5LDIuMDc0LDAuMzQ5LDMuMDU2Yy0xMS4xNDQtMC41NTktMjEuMDI1LTUuODk3LTI3LjYzOS0xNC4wMTJjLTEuMTU0LDEuOTgtMS44MTYsNC4yODUtMS44MTYsNi43NDIgICAgYzAsNC42NTEsMi4zNjksOC43NTcsNS45NjUsMTEuMTYxYy0yLjE5Ny0wLjA2OS00LjI2Ni0wLjY3Mi02LjA3My0xLjY3OWMtMC4wMDEsMC4wNTctMC4wMDEsMC4xMTQtMC4wMDEsMC4xNyAgICBjMCw2LjQ5Nyw0LjYyNCwxMS45MTYsMTAuNzU3LDEzLjE0N2MtMS4xMjQsMC4zMDgtMi4zMTEsMC40NzEtMy41MzIsMC40NzFjLTAuODY2LDAtMS43MDUtMC4wODMtMi41MjMtMC4yMzkgICAgYzEuNzA2LDUuMzI2LDYuNjU3LDkuMjAzLDEyLjUyNiw5LjMxMmMtNC41OSwzLjU5Ny0xMC4zNzEsNS43NC0xNi42NTUsNS43NGMtMS4wOCwwLTIuMTUtMC4wNjMtMy4xOTctMC4xODggICAgYzUuOTMxLDMuODA2LDEyLjk4MSw2LjAyNSwyMC41NTMsNi4wMjVjMjQuNjY0LDAsMzguMTUyLTIwLjQzMiwzOC4xNTItMzguMTUzYzAtMC41ODEtMC4wMTMtMS4xNi0wLjAzOS0xLjczNCAgICBDODYuMzkxLDQ1LjM2Niw4OC42NjQsNDMuMDA1LDkwLjQ2MSw0MC4zMTZMOTAuNDYxLDQwLjMxNnoiCiAgICAgIGZpbGw9IiNGRkYiLz4KPC9nPgo8L3N2Zz4K");

;// CONCATENATED MODULE: ./src/assets/svg/social/facebook-share.svg
function facebook_share_extends() { facebook_share_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return facebook_share_extends.apply(this, arguments); }



var facebook_share_ref = /*#__PURE__*/react.createElement("rect", {
  width: 112.196,
  height: 112.196,
  rx: 20,
  ry: 20,
  fill: "#3b5998"
});

var facebook_share_ref2 = /*#__PURE__*/react.createElement("g", {
  transform: "matrix(0.7,0,0,0.7,16.829399871826176,16.829399871826176)"
}, /*#__PURE__*/react.createElement("circle", {
  cx: 56.098,
  cy: 56.098,
  r: 56.098,
  fill: "#3b5998"
}), /*#__PURE__*/react.createElement("path", {
  d: "M70.201,58.294h-10.01v36.672H45.025V58.294h-7.213V45.406h7.213v-8.34   c0-5.964,2.833-15.303,15.301-15.303L71.56,21.81v12.51h-8.151c-1.337,0-3.217,0.668-3.217,3.513v7.585h11.334L70.201,58.294z",
  fill: "#ffffff"
}));

function SvgFacebookShare({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react.createElement("svg", facebook_share_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 112.196 112.196",
    xmlSpace: "preserve",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, facebook_share_ref, facebook_share_ref2);
}

/* harmony default export */ var facebook_share = ("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgd2lkdGg9IjUxMiIgaGVpZ2h0PSI1MTIiIHg9IjAiIHk9IjAiIHZpZXdCb3g9IjAgMCAxMTIuMTk2IDExMi4xOTYiIHhtbDpzcGFjZT0icHJlc2VydmUiID4KICA8cmVjdCB3aWR0aD0iMTEyLjE5NiIgaGVpZ2h0PSIxMTIuMTk2IiByeD0iMjAiIHJ5PSIyMCIgZmlsbD0iIzNiNTk5OCIgLz4KICA8ZyB0cmFuc2Zvcm09Im1hdHJpeCgwLjcsMCwwLDAuNywxNi44MjkzOTk4NzE4MjYxNzYsMTYuODI5Mzk5ODcxODI2MTc2KSI+Cgk8Y2lyY2xlIGN4PSI1Ni4wOTgiIGN5PSI1Ni4wOTgiIHI9IjU2LjA5OCIgZmlsbD0iIzNiNTk5OCIvPgogIDxwYXRoCiAgICAgICAgZD0iTTcwLjIwMSw1OC4yOTRoLTEwLjAxdjM2LjY3Mkg0NS4wMjVWNTguMjk0aC03LjIxM1Y0NS40MDZoNy4yMTN2LTguMzQgICBjMC01Ljk2NCwyLjgzMy0xNS4zMDMsMTUuMzAxLTE1LjMwM0w3MS41NiwyMS44MXYxMi41MWgtOC4xNTFjLTEuMzM3LDAtMy4yMTcsMC42NjgtMy4yMTcsMy41MTN2Ny41ODVoMTEuMzM0TDcwLjIwMSw1OC4yOTR6IgogICAgICAgIGZpbGw9IiNmZmZmZmYiIC8+CjwvZz4KPC9zdmc+Cg==");

;// CONCATENATED MODULE: ./src/assets/svg/social/vk-share.svg
function vk_share_extends() { vk_share_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return vk_share_extends.apply(this, arguments); }



var vk_share_ref = /*#__PURE__*/react.createElement("rect", {
  width: 112.196,
  height: 112.196,
  rx: 20,
  ry: 20,
  fill: "#4D76A1"
});

var vk_share_ref2 = /*#__PURE__*/react.createElement("circle", {
  cx: 56.098,
  cy: 56.098,
  r: 56.098,
  fill: "#4D76A1"
});

function SvgVkShare({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react.createElement("svg", vk_share_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 112.196 112.196",
    xmlSpace: "preserve",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, vk_share_ref, /*#__PURE__*/react.createElement("g", {
    transform: "matrix(0.7,0,0,0.7,16.829399871826176,16.829399871826176)"
  }, vk_share_ref2, /*#__PURE__*/react.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M53.979,80.702h4.403c0,0,1.33-0.146,2.009-0.878   c0.625-0.672,0.605-1.934,0.605-1.934s-0.086-5.908,2.656-6.778c2.703-0.857,6.174,5.71,9.853,8.235   c2.782,1.911,4.896,1.492,4.896,1.492l9.837-0.137c0,0,5.146-0.317,2.706-4.363c-0.2-0.331-1.421-2.993-7.314-8.463   c-6.168-5.725-5.342-4.799,2.088-14.702c4.525-6.031,6.334-9.713,5.769-11.29c-0.539-1.502-3.867-1.105-3.867-1.105l-11.076,0.069   c0,0-0.821-0.112-1.43,0.252c-0.595,0.357-0.978,1.189-0.978,1.189s-1.753,4.667-4.091,8.636c-4.932,8.375-6.904,8.817-7.71,8.297   c-1.875-1.212-1.407-4.869-1.407-7.467c0-8.116,1.231-11.5-2.397-12.376c-1.204-0.291-2.09-0.483-5.169-0.514   c-3.952-0.041-7.297,0.012-9.191,0.94c-1.26,0.617-2.232,1.992-1.64,2.071c0.732,0.098,2.39,0.447,3.269,1.644   c1.135,1.544,1.095,5.012,1.095,5.012s0.652,9.554-1.523,10.741c-1.493,0.814-3.541-0.848-7.938-8.446   c-2.253-3.892-3.954-8.194-3.954-8.194s-0.328-0.804-0.913-1.234c-0.71-0.521-1.702-0.687-1.702-0.687l-10.525,0.069   c0,0-1.58,0.044-2.16,0.731c-0.516,0.611-0.041,1.875-0.041,1.875s8.24,19.278,17.57,28.993   C44.264,81.287,53.979,80.702,53.979,80.702L53.979,80.702z"
  })));
}

/* harmony default export */ var vk_share = ("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciCiAgICAgdmVyc2lvbj0iMS4xIiB3aWR0aD0iNTEyIiBoZWlnaHQ9IjUxMiIgeD0iMCIgeT0iMCIgdmlld0JveD0iMCAwIDExMi4xOTYgMTEyLjE5NiIKICAgICB4bWw6c3BhY2U9InByZXNlcnZlIj4KICA8cmVjdCB3aWR0aD0iMTEyLjE5NiIgaGVpZ2h0PSIxMTIuMTk2IiByeD0iMjAiIHJ5PSIyMCIgZmlsbD0iIzRENzZBMSIvPgogIDxnIHRyYW5zZm9ybT0ibWF0cml4KDAuNywwLDAsMC43LDE2LjgyOTM5OTg3MTgyNjE3NiwxNi44MjkzOTk4NzE4MjYxNzYpIj4KCQk8Y2lyY2xlIGN4PSI1Ni4wOTgiIGN5PSI1Ni4wOTgiIHI9IjU2LjA5OCIgZmlsbD0iIzRENzZBMSIgLz4KICAgIDxwYXRoIHN0eWxlPSJmaWxsOiNGRkZGRkY7IgogICAgICAgICAgZD0iTTUzLjk3OSw4MC43MDJoNC40MDNjMCwwLDEuMzMtMC4xNDYsMi4wMDktMC44NzggICBjMC42MjUtMC42NzIsMC42MDUtMS45MzQsMC42MDUtMS45MzRzLTAuMDg2LTUuOTA4LDIuNjU2LTYuNzc4YzIuNzAzLTAuODU3LDYuMTc0LDUuNzEsOS44NTMsOC4yMzUgICBjMi43ODIsMS45MTEsNC44OTYsMS40OTIsNC44OTYsMS40OTJsOS44MzctMC4xMzdjMCwwLDUuMTQ2LTAuMzE3LDIuNzA2LTQuMzYzYy0wLjItMC4zMzEtMS40MjEtMi45OTMtNy4zMTQtOC40NjMgICBjLTYuMTY4LTUuNzI1LTUuMzQyLTQuNzk5LDIuMDg4LTE0LjcwMmM0LjUyNS02LjAzMSw2LjMzNC05LjcxMyw1Ljc2OS0xMS4yOWMtMC41MzktMS41MDItMy44NjctMS4xMDUtMy44NjctMS4xMDVsLTExLjA3NiwwLjA2OSAgIGMwLDAtMC44MjEtMC4xMTItMS40MywwLjI1MmMtMC41OTUsMC4zNTctMC45NzgsMS4xODktMC45NzgsMS4xODlzLTEuNzUzLDQuNjY3LTQuMDkxLDguNjM2Yy00LjkzMiw4LjM3NS02LjkwNCw4LjgxNy03LjcxLDguMjk3ICAgYy0xLjg3NS0xLjIxMi0xLjQwNy00Ljg2OS0xLjQwNy03LjQ2N2MwLTguMTE2LDEuMjMxLTExLjUtMi4zOTctMTIuMzc2Yy0xLjIwNC0wLjI5MS0yLjA5LTAuNDgzLTUuMTY5LTAuNTE0ICAgYy0zLjk1Mi0wLjA0MS03LjI5NywwLjAxMi05LjE5MSwwLjk0Yy0xLjI2LDAuNjE3LTIuMjMyLDEuOTkyLTEuNjQsMi4wNzFjMC43MzIsMC4wOTgsMi4zOSwwLjQ0NywzLjI2OSwxLjY0NCAgIGMxLjEzNSwxLjU0NCwxLjA5NSw1LjAxMiwxLjA5NSw1LjAxMnMwLjY1Miw5LjU1NC0xLjUyMywxMC43NDFjLTEuNDkzLDAuODE0LTMuNTQxLTAuODQ4LTcuOTM4LTguNDQ2ICAgYy0yLjI1My0zLjg5Mi0zLjk1NC04LjE5NC0zLjk1NC04LjE5NHMtMC4zMjgtMC44MDQtMC45MTMtMS4yMzRjLTAuNzEtMC41MjEtMS43MDItMC42ODctMS43MDItMC42ODdsLTEwLjUyNSwwLjA2OSAgIGMwLDAtMS41OCwwLjA0NC0yLjE2LDAuNzMxYy0wLjUxNiwwLjYxMS0wLjA0MSwxLjg3NS0wLjA0MSwxLjg3NXM4LjI0LDE5LjI3OCwxNy41NywyOC45OTMgICBDNDQuMjY0LDgxLjI4Nyw1My45NzksODAuNzAyLDUzLjk3OSw4MC43MDJMNTMuOTc5LDgwLjcwMnoiLz4KPC9nPgo8L3N2Zz4K");

;// CONCATENATED MODULE: ./src/assets/svg/social/odnoklassniki.svg
function odnoklassniki_extends() { odnoklassniki_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return odnoklassniki_extends.apply(this, arguments); }



var odnoklassniki_ref = /*#__PURE__*/react.createElement("rect", {
  width: 512,
  height: 512,
  rx: 70,
  ry: 70,
  fill: "#ff9800"
});

var odnoklassniki_ref2 = /*#__PURE__*/react.createElement("g", {
  transform: "matrix(0.5,0,0,0.5,128.12019348144534,128.11961364746074)"
}, /*#__PURE__*/react.createElement("path", {
  d: "M256.239,277.333c76.583,0,138.667-62.083,138.667-138.667S332.823,0,256.239,0   S117.573,62.083,117.573,138.667C117.667,215.211,179.695,277.239,256.239,277.333z M256.239,64   c41.237,0,74.667,33.429,74.667,74.667s-33.429,74.667-74.667,74.667s-74.667-33.429-74.667-74.667S215.002,64,256.239,64z",
  fill: "#ffffff"
}), /*#__PURE__*/react.createElement("path", {
  d: "M392.069,343.04c15.07-9.926,24.15-26.755,24.171-44.8c0.21-14.976-8.241-28.728-21.696-35.307   c-13.824-6.905-30.372-5.35-42.667,4.011c-56.983,41.543-134.27,41.543-191.253,0c-12.314-9.312-28.833-10.865-42.667-4.011   c-13.449,6.578-21.904,20.315-21.717,35.285c0.032,18.042,9.109,34.866,24.171,44.8c19.324,12.851,40.368,22.906,62.507,29.867   c3.755,1.166,7.63,2.247,11.627,3.243l-64.469,63.04c-16.912,16.409-17.321,43.42-0.912,60.333   c16.409,16.912,43.42,17.321,60.333,0.912c0.352-0.342,0.698-0.689,1.038-1.043l65.707-68.011l65.835,68.139   c16.395,16.925,43.407,17.355,60.332,0.96c16.925-16.395,17.355-43.407,0.96-60.332c-0.343-0.354-0.692-0.702-1.047-1.044   l-64.363-62.976c3.996-1.024,7.886-2.112,11.669-3.264C351.743,365.908,372.767,355.874,392.069,343.04z",
  fill: "#ffffff"
}));

function SvgOdnoklassniki({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react.createElement("svg", odnoklassniki_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, odnoklassniki_ref, odnoklassniki_ref2);
}

/* harmony default export */ var odnoklassniki = ("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+CiAgPHJlY3Qgd2lkdGg9IjUxMiIgaGVpZ2h0PSI1MTIiIHJ4PSI3MCIgcnk9IjcwIiBmaWxsPSIjZmY5ODAwIiAvPgogIDxnIHRyYW5zZm9ybT0ibWF0cml4KDAuNSwwLDAsMC41LDEyOC4xMjAxOTM0ODE0NDUzNCwxMjguMTE5NjEzNjQ3NDYwNzQpIj4KCTxwYXRoCiAgICAgICAgZD0iTTI1Ni4yMzksMjc3LjMzM2M3Ni41ODMsMCwxMzguNjY3LTYyLjA4MywxMzguNjY3LTEzOC42NjdTMzMyLjgyMywwLDI1Ni4yMzksMCAgIFMxMTcuNTczLDYyLjA4MywxMTcuNTczLDEzOC42NjdDMTE3LjY2NywyMTUuMjExLDE3OS42OTUsMjc3LjIzOSwyNTYuMjM5LDI3Ny4zMzN6IE0yNTYuMjM5LDY0ICAgYzQxLjIzNywwLDc0LjY2NywzMy40MjksNzQuNjY3LDc0LjY2N3MtMzMuNDI5LDc0LjY2Ny03NC42NjcsNzQuNjY3cy03NC42NjctMzMuNDI5LTc0LjY2Ny03NC42NjdTMjE1LjAwMiw2NCwyNTYuMjM5LDY0eiIKICAgICAgICBmaWxsPSIjZmZmZmZmIiAvPgogIDxwYXRoCiAgICAgICAgZD0iTTM5Mi4wNjksMzQzLjA0YzE1LjA3LTkuOTI2LDI0LjE1LTI2Ljc1NSwyNC4xNzEtNDQuOGMwLjIxLTE0Ljk3Ni04LjI0MS0yOC43MjgtMjEuNjk2LTM1LjMwNyAgIGMtMTMuODI0LTYuOTA1LTMwLjM3Mi01LjM1LTQyLjY2Nyw0LjAxMWMtNTYuOTgzLDQxLjU0My0xMzQuMjcsNDEuNTQzLTE5MS4yNTMsMGMtMTIuMzE0LTkuMzEyLTI4LjgzMy0xMC44NjUtNDIuNjY3LTQuMDExICAgYy0xMy40NDksNi41NzgtMjEuOTA0LDIwLjMxNS0yMS43MTcsMzUuMjg1YzAuMDMyLDE4LjA0Miw5LjEwOSwzNC44NjYsMjQuMTcxLDQ0LjhjMTkuMzI0LDEyLjg1MSw0MC4zNjgsMjIuOTA2LDYyLjUwNywyOS44NjcgICBjMy43NTUsMS4xNjYsNy42MywyLjI0NywxMS42MjcsMy4yNDNsLTY0LjQ2OSw2My4wNGMtMTYuOTEyLDE2LjQwOS0xNy4zMjEsNDMuNDItMC45MTIsNjAuMzMzICAgYzE2LjQwOSwxNi45MTIsNDMuNDIsMTcuMzIxLDYwLjMzMywwLjkxMmMwLjM1Mi0wLjM0MiwwLjY5OC0wLjY4OSwxLjAzOC0xLjA0M2w2NS43MDctNjguMDExbDY1LjgzNSw2OC4xMzkgICBjMTYuMzk1LDE2LjkyNSw0My40MDcsMTcuMzU1LDYwLjMzMiwwLjk2YzE2LjkyNS0xNi4zOTUsMTcuMzU1LTQzLjQwNywwLjk2LTYwLjMzMmMtMC4zNDMtMC4zNTQtMC42OTItMC43MDItMS4wNDctMS4wNDQgICBsLTY0LjM2My02Mi45NzZjMy45OTYtMS4wMjQsNy44ODYtMi4xMTIsMTEuNjY5LTMuMjY0QzM1MS43NDMsMzY1LjkwOCwzNzIuNzY3LDM1NS44NzQsMzkyLjA2OSwzNDMuMDR6IgogICAgICAgIGZpbGw9IiNmZmZmZmYiIC8+Cgo8L2c+PC9zdmc+Cg==");

;// CONCATENATED MODULE: ./src/assets/svg/social/telegram-share.svg
function telegram_share_extends() { telegram_share_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return telegram_share_extends.apply(this, arguments); }



var telegram_share_ref = /*#__PURE__*/react.createElement("rect", {
  width: 455.731,
  height: 455.731,
  rx: 100,
  ry: 100,
  fill: "#40B0EF"
});

var telegram_share_ref2 = /*#__PURE__*/react.createElement("g", {
  transform: "matrix(0.7,0,0,0.7,68.35964813232422,68.35964813232422)"
}, /*#__PURE__*/react.createElement("rect", {
  x: 0,
  y: 0,
  width: 455.731,
  height: 455.731,
  fill: "#40B0EF"
}), /*#__PURE__*/react.createElement("path", {
  d: "M358.844,100.6L54.091,219.359c-9.871,3.847-9.273,18.012,0.888,21.012l77.441,22.868l28.901,91.706   c3.019,9.579,15.158,12.483,22.185,5.308l40.039-40.882l78.56,57.665c9.614,7.057,23.306,1.814,25.747-9.859l52.031-248.76   C382.431,106.232,370.443,96.08,358.844,100.6z M320.636,155.806L179.08,280.984c-1.411,1.248-2.309,2.975-2.519,4.847   l-5.45,48.448c-0.178,1.58-2.389,1.789-2.861,0.271l-22.423-72.253c-1.027-3.308,0.312-6.892,3.255-8.717l167.163-103.676   C320.089,147.518,324.025,152.81,320.636,155.806z",
  fill: "#ffffff"
}));

function SvgTelegramShare({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react.createElement("svg", telegram_share_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 455.731 455.731",
    xmlSpace: "preserve",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, telegram_share_ref, telegram_share_ref2);
}

/* harmony default export */ var telegram_share = ("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgd2lkdGg9IjUxMiIgaGVpZ2h0PSI1MTIiIHg9IjAiIHk9IjAiIHZpZXdCb3g9IjAgMCA0NTUuNzMxIDQ1NS43MzEiIHhtbDpzcGFjZT0icHJlc2VydmUiID4KICA8cmVjdCB3aWR0aD0iNDU1LjczMSIgaGVpZ2h0PSI0NTUuNzMxIiByeD0iMTAwIiByeT0iMTAwIiBmaWxsPSIjNDBCMEVGIi8+CiAgPGcgdHJhbnNmb3JtPSJtYXRyaXgoMC43LDAsMCwwLjcsNjguMzU5NjQ4MTMyMzI0MjIsNjguMzU5NjQ4MTMyMzI0MjIpIj4KCTxyZWN0IHg9IjAiIHk9IjAiIHdpZHRoPSI0NTUuNzMxIiBoZWlnaHQ9IjQ1NS43MzEiIGZpbGw9IiM0MEIwRUYiLz4KICA8cGF0aAogICAgZD0iTTM1OC44NDQsMTAwLjZMNTQuMDkxLDIxOS4zNTljLTkuODcxLDMuODQ3LTkuMjczLDE4LjAxMiwwLjg4OCwyMS4wMTJsNzcuNDQxLDIyLjg2OGwyOC45MDEsOTEuNzA2ICAgYzMuMDE5LDkuNTc5LDE1LjE1OCwxMi40ODMsMjIuMTg1LDUuMzA4bDQwLjAzOS00MC44ODJsNzguNTYsNTcuNjY1YzkuNjE0LDcuMDU3LDIzLjMwNiwxLjgxNCwyNS43NDctOS44NTlsNTIuMDMxLTI0OC43NiAgIEMzODIuNDMxLDEwNi4yMzIsMzcwLjQ0Myw5Ni4wOCwzNTguODQ0LDEwMC42eiBNMzIwLjYzNiwxNTUuODA2TDE3OS4wOCwyODAuOTg0Yy0xLjQxMSwxLjI0OC0yLjMwOSwyLjk3NS0yLjUxOSw0Ljg0NyAgIGwtNS40NSw0OC40NDhjLTAuMTc4LDEuNTgtMi4zODksMS43ODktMi44NjEsMC4yNzFsLTIyLjQyMy03Mi4yNTNjLTEuMDI3LTMuMzA4LDAuMzEyLTYuODkyLDMuMjU1LTguNzE3bDE2Ny4xNjMtMTAzLjY3NiAgIEMzMjAuMDg5LDE0Ny41MTgsMzI0LjAyNSwxNTIuODEsMzIwLjYzNiwxNTUuODA2eiIKICAgIGZpbGw9IiNmZmZmZmYiLz4KPC9nPgo8L3N2Zz4K");

;// CONCATENATED MODULE: ./src/assets/svg/social/viber-share.svg
function viber_share_extends() { viber_share_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return viber_share_extends.apply(this, arguments); }



var viber_share_ref = /*#__PURE__*/react.createElement("rect", {
  width: 512.002,
  height: 512.002,
  rx: 100,
  ry: 100,
  fill: "#7f40bd",
  transform: "matrix(1,0,0,1,0,0)"
});

var viber_share_ref2 = /*#__PURE__*/react.createElement("g", {
  transform: "matrix(0.44,0,0,0.44,143.36044673919673,143.36027343749993)"
}, /*#__PURE__*/react.createElement("path", {
  d: "M437.976,214.854c0.615-72.186-60.866-138.361-137.051-147.512c-1.515-0.18-3.166-0.453-4.913-0.743   c-3.772-0.625-7.672-1.267-11.607-1.267c-15.614,0-19.788,10.968-20.887,17.51c-1.069,6.36-0.049,11.701,3.024,15.882   c5.171,7.031,14.269,8.279,21.577,9.28c2.142,0.296,4.163,0.571,5.855,0.951c68.449,15.295,91.497,39.341,102.761,107.208   c0.275,1.658,0.399,3.702,0.531,5.869c0.491,8.113,1.515,24.991,19.661,24.991h0.002c1.511,0,3.134-0.13,4.824-0.388   c16.898-2.568,16.368-17.996,16.114-25.409c-0.072-2.088-0.14-4.063,0.037-5.376C437.95,215.519,437.974,215.186,437.976,214.854z",
  fill: "#fff"
}), /*#__PURE__*/react.createElement("path", {
  d: "M279.974,40.846c2.027,0.146,3.947,0.286,5.545,0.531c112.4,17.286,164.091,70.54,178.416,183.819   c0.243,1.926,0.281,4.274,0.321,6.761c0.143,8.85,0.437,27.262,20.21,27.643l0.614,0.006c6.201,0,11.134-1.87,14.662-5.562   c6.155-6.438,5.726-16.002,5.379-23.689c-0.084-1.886-0.165-3.662-0.145-5.217C506.405,109.283,406.12,4.226,290.369,0.32   c-0.48-0.016-0.938,0.01-1.401,0.075c-0.227,0.033-0.649,0.075-1.371,0.075c-1.154,0-2.574-0.1-4.08-0.202   C281.696,0.143,279.632,0,277.54,0c-18.434,0-21.938,13.102-22.386,20.912C254.12,38.963,271.582,40.233,279.974,40.846z",
  fill: "#fff"
}), /*#__PURE__*/react.createElement("path", {
  d: "M458.511,371.602c-2.39-1.825-4.861-3.714-7.174-5.578c-12.272-9.876-25.328-18.979-37.955-27.783   c-2.62-1.825-5.241-3.652-7.852-5.484c-16.174-11.361-30.715-16.882-44.453-16.882c-18.504,0-34.636,10.224-47.951,30.384   c-5.899,8.938-13.056,13.283-21.876,13.283c-5.215,0-11.142-1.488-17.612-4.425c-52.207-23.674-89.486-59.972-110.803-107.886   c-10.305-23.158-6.964-38.295,11.172-50.615c10.299-6.99,29.469-20.003,28.111-44.922c-1.538-28.298-63.976-113.445-90.284-123.115   c-11.138-4.096-22.841-4.134-34.846-0.095C46.744,38.651,25.041,56.506,14.219,80.115c-10.458,22.813-9.986,49.599,1.366,77.463   C48.401,238.14,94.538,308.38,152.72,366.342c56.95,56.74,126.946,103.217,208.042,138.137c7.31,3.145,14.977,4.861,20.575,6.112   c1.908,0.429,3.555,0.795,4.756,1.124c0.66,0.18,1.34,0.277,2.023,0.283l0.641,0.003c0.002,0,0,0,0.003,0   c38.142,0,83.941-34.854,98.007-74.59C499.09,402.618,476.59,385.42,458.511,371.602z",
  fill: "#fff"
}), /*#__PURE__*/react.createElement("path", {
  d: "M296.845,132.872c-6.53,0.165-20.121,0.502-24.889,14.344c-2.231,6.468-1.964,12.084,0.795,16.692   c4.048,6.761,11.805,8.833,18.86,9.97c25.586,4.106,38.726,18.254,41.354,44.522c1.221,12.248,9.469,20.801,20.059,20.801h0.002   c0.782,0,1.582-0.046,2.379-0.143c12.736-1.515,18.911-10.873,18.353-27.81c0.204-17.677-9.047-37.745-24.781-53.73   C333.187,141.484,314.156,132.454,296.845,132.872z",
  fill: "#fff"
}));

function SvgViberShare({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react.createElement("svg", viber_share_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512.002 512.002",
    xmlSpace: "preserve",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, viber_share_ref, viber_share_ref2);
}

/* harmony default export */ var viber_share = ("data:image/svg+xml;base64,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");

;// CONCATENATED MODULE: ./src/components/Share/constants.ts






const shareListItem = [{
  itemIcon: SvgVkShare,
  link: 'https://vk.com/share.php?url=',
  title: 'VK'
}, {
  itemIcon: SvgFacebookShare,
  link: 'https://www.facebook.com/sharer.php?u=',
  title: 'Facebook'
}, {
  itemIcon: SvgOdnoklassniki,
  link: 'https://connect.ok.ru/offer?url=',
  title: 'OK'
}, {
  itemIcon: SvgTelegramShare,
  link: 'https://t.me/share/url?url=',
  title: 'Telegram'
}, {
  itemIcon: SvgViberShare,
  link: 'viber://forward?text=',
  title: 'Viber'
}, {
  itemIcon: SvgTwitterShare,
  link: 'https://twitter.com/intent/tweet?url=',
  title: 'Twitter',
  text: true
}];
;// CONCATENATED MODULE: ./src/components/Share/Share.tsx









const Share = ({
  postTitle,
  className
}) => {
  const t = (0,production/* useTranslations */.T_)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Share_Component, {
    className: className,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Title, {
      children: [t('share'), ":"]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(List, {
      children: shareListItem.map((shareItem, index) => /*#__PURE__*/(0,jsx_runtime.jsx)(Item, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ShareButton, {
          href: (0,web_core_esm.isBrowser)() ? `${shareItem.link}${window.location.href}${shareItem.text ? `&text=${postTitle}` : ''}` : '',
          title: `${t('share_in')} ${shareItem.title}`,
          target: "_blank",
          children: /*#__PURE__*/react.createElement(shareItem.itemIcon)
        })
      }, index))
    })]
  });
};

/* harmony default export */ var Share_Share = (Share);
const Share_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Share__Component",
  componentId: "sc-1e68he8-0"
})([""]);
const Title = styled_components_browser_esm["default"].span.withConfig({
  displayName: "Share__Title",
  componentId: "sc-1e68he8-1"
})(["font-size:14px;line-height:20px;font-weight:600;"]);
const List = styled_components_browser_esm["default"].ul.withConfig({
  displayName: "Share__List",
  componentId: "sc-1e68he8-2"
})(["margin-top:3px;display:flex;"]);
const Item = styled_components_browser_esm["default"].li.withConfig({
  displayName: "Share__Item",
  componentId: "sc-1e68he8-3"
})(["&:not(:first-child){margin-left:0.625rem;}"]);
const ShareButton = (0,styled_components_browser_esm["default"])(Button/* ButtonLink */.Z).withConfig({
  displayName: "Share__ShareButton",
  componentId: "sc-1e68he8-4"
})(["width:28px;height:28px;svg{width:100%;height:100%;}"]);
;// CONCATENATED MODULE: ./src/components/Share/index.ts

// EXTERNAL MODULE: ./node_modules/@tager/web-modules/dist/web-modules.esm.js
var web_modules_esm = __webpack_require__(56640);
// EXTERNAL MODULE: ./src/components/Picture.tsx
var Picture = __webpack_require__(97377);
;// CONCATENATED MODULE: ./src/modules/Post/components/Main/components/Hero/Hero.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









const Hero = ({
  title,
  image,
  categories
}) => {
  if (!categories.length) return null;
  const category = categories[0];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Hero_Component, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Hero_Title, {
      children: title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ImageWrapper, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Inner, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Image, _objectSpread({}, (0,web_modules_esm/* convertThumbnailToPictureProps */.VM)(image))), category && /*#__PURE__*/(0,jsx_runtime.jsx)(Category, {
          children: category.name
        })]
      })
    })]
  });
};

/* harmony default export */ var Hero_Hero = (Hero);
const Hero_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Hero__Component",
  componentId: "sc-2muxi7-0"
})([""]);
const Hero_Title = styled_components_browser_esm["default"].span.withConfig({
  displayName: "Hero__Title",
  componentId: "sc-2muxi7-1"
})(["font-style:normal;font-weight:500;font-size:18px;line-height:34px;"]);
const Image = (0,styled_components_browser_esm["default"])(Picture/* default */.Z).withConfig({
  displayName: "Hero__Image",
  componentId: "sc-2muxi7-2"
})(["position:absolute;width:100%;height:100%;picture,img{width:100%;height:100%;}"]);
const ImageWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Hero__ImageWrapper",
  componentId: "sc-2muxi7-3"
})(["margin:0 -15px;"]);
const Inner = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Hero__Inner",
  componentId: "sc-2muxi7-4"
})(["position:relative;padding-bottom:min(47.77%,400px);"]);
const Category = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Hero__Category",
  componentId: "sc-2muxi7-5"
})(["position:absolute;padding:0 7px;left:0;bottom:1px;background:", ";color:", ";font-style:normal;font-weight:500;font-size:11px;line-height:22px;"], theme/* colors.primary */.O9.primary, theme/* colors.white */.O9.white);
;// CONCATENATED MODULE: ./src/modules/Post/components/Main/components/Hero/index.ts

;// CONCATENATED MODULE: ./src/modules/Post/components/Main/components/Excerpt/Excerpt.tsx





const Excerpt = ({
  text
}) => {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Excerpt_Component, {
    children: text
  });
};

/* harmony default export */ var Excerpt_Excerpt = (Excerpt);
const Excerpt_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Excerpt__Component",
  componentId: "sc-m71ue6-0"
})(["margin:1.1875rem -15px;padding:1rem 0 1.125rem;text-align:center;font-style:italic;font-weight:500;font-size:14px;line-height:24px;background:", ";"], theme/* colors.gray237 */.O9.gray237);
;// CONCATENATED MODULE: ./src/modules/Post/components/Main/components/Excerpt/index.ts

;// CONCATENATED MODULE: ./src/modules/Post/components/Main/components/Tags/Tags.tsx







const Tags = ({
  tags,
  className
}) => {
  const t = (0,production/* useTranslations */.T_)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Tags_Component, {
    className: className,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Label, {
      children: [t('blog.tags'), ":"]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Tags_List, {
      className: "tags-list",
      children: tags.map((tag, index) => /*#__PURE__*/(0,jsx_runtime.jsx)(Tag, {
        children: tag
      }, index))
    })]
  });
};

/* harmony default export */ var Tags_Tags = (Tags);
const Tags_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Tags__Component",
  componentId: "sc-drj5fb-0"
})([".tags-list::-webkit-scrollbar{-webkit-appearance:none;height:1px;}.tags-list::-webkit-scrollbar-thumb{position:absolute;top:0;border-radius:4px;background-color:", ";}"], theme/* colors.grayLighter */.O9.grayLighter);
const Label = styled_components_browser_esm["default"].span.withConfig({
  displayName: "Tags__Label",
  componentId: "sc-drj5fb-1"
})(["font-style:normal;font-weight:500;font-size:14px;line-height:24px;"]);
const Tags_List = styled_components_browser_esm["default"].ul.withConfig({
  displayName: "Tags__List",
  componentId: "sc-drj5fb-2"
})(["overflow-x:auto;display:flex;align-items:center;white-space:nowrap;& > li:not(:first-child){margin-left:1.125rem;}"]);
const Tag = styled_components_browser_esm["default"].li.withConfig({
  displayName: "Tags__Tag",
  componentId: "sc-drj5fb-3"
})(["font-style:normal;font-weight:500;font-size:12px;line-height:24px;color:", ";"], theme/* colors.primary */.O9.primary);
;// CONCATENATED MODULE: ./src/modules/Post/components/Main/components/Tags/index.ts

;// CONCATENATED MODULE: ./src/modules/Post/components/Main/components/Description/Description.tsx





const Description = ({
  className,
  description
}) => {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Description_Component, {
    className: className,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text, {
      children: description
    })
  });
};

/* harmony default export */ var Description_Description = (Description);
const Description_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Description__Component",
  componentId: "sc-dpojnj-0"
})(["padding:1rem 1rem 1.1875rem;border:2px solid ", ";"], theme/* colors.primary */.O9.primary);
const Text = styled_components_browser_esm["default"].p.withConfig({
  displayName: "Description__Text",
  componentId: "sc-dpojnj-1"
})(["font-style:normal;font-weight:600;font-size:13px;line-height:20px;color:", ";"], theme/* colors.primary */.O9.primary);
;// CONCATENATED MODULE: ./src/modules/Post/components/Main/components/Description/index.ts

;// CONCATENATED MODULE: ./src/modules/Post/components/Main/MainView.tsx











const MainView = ({
  post
}) => {
  var _post$pageTitle, _post$categories, _post$title;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(MainView_Component, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Hero_Hero, {
      title: (_post$pageTitle = post === null || post === void 0 ? void 0 : post.pageTitle) !== null && _post$pageTitle !== void 0 ? _post$pageTitle : '',
      image: post === null || post === void 0 ? void 0 : post.image.inner,
      categories: (_post$categories = post === null || post === void 0 ? void 0 : post.categories) !== null && _post$categories !== void 0 ? _post$categories : []
    }), (post === null || post === void 0 ? void 0 : post.excerpt) && /*#__PURE__*/(0,jsx_runtime.jsx)(Excerpt_Excerpt, {
      text: post.excerpt
    }), (post === null || post === void 0 ? void 0 : post.body) && /*#__PURE__*/(0,jsx_runtime.jsx)(Body, {
      className: "post-body-wrapper",
      dangerouslySetInnerHTML: {
        __html: post.body
      }
    }), (post === null || post === void 0 ? void 0 : post.pageDescription) && /*#__PURE__*/(0,jsx_runtime.jsx)(Description_Description, {
      description: post.pageDescription,
      className: "blog-post-description"
    }), (post === null || post === void 0 ? void 0 : post.tags) && (post === null || post === void 0 ? void 0 : post.tags.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(Tags_Tags, {
      tags: post.tags,
      className: "blog-post-tags"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Share_Share, {
      postTitle: (_post$title = post === null || post === void 0 ? void 0 : post.title) !== null && _post$title !== void 0 ? _post$title : '',
      className: "blog-post-share"
    })]
  });
};

/* harmony default export */ var Main_MainView = (MainView);
const MainView_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "MainView__Component",
  componentId: "sc-tzebdw-0"
})([".post-body-wrapper{p{margin-top:1.6875rem;}p:first-child{margin-top:0.875rem;}img{margin:1.5625rem auto 0;}h2{margin:1.875rem 0 0.9375rem;}p a{color:", ";text-decoration:underline;}}.blog-post-tags{margin-top:1.4375rem;}.blog-post-description{margin-top:1.625rem;}.blog-post-share{margin-top:1rem;}"], theme/* colors.primary */.O9.primary);
const Body = styled_components_browser_esm["default"].div.withConfig({
  displayName: "MainView__Body",
  componentId: "sc-tzebdw-1"
})([""]);
;// CONCATENATED MODULE: ./src/modules/Post/components/Main/Main.tsx




const Main = ({
  post
}) => {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Main_MainView, {
    post: post
  });
};

/* harmony default export */ var Main_Main = (Main);
;// CONCATENATED MODULE: ./src/modules/Post/components/Main/index.ts

;// CONCATENATED MODULE: ./src/modules/Post/PostView.tsx








const PostView = ({
  post
}) => {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(PostView_Component, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ContentContainer/* default */.Z, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_Top, {
        urlAlias: post === null || post === void 0 ? void 0 : post.urlAlias,
        pageName: post === null || post === void 0 ? void 0 : post.title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Main_Main, {
        post: post
      })]
    })
  });
};

/* harmony default export */ var Post_PostView = (PostView);
const PostView_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "PostView__Component",
  componentId: "sc-1mhe5qr-0"
})([""]);
;// CONCATENATED MODULE: ./src/modules/Post/Post.tsx




const Post = ({
  post
}) => {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Post_PostView, {
    post: post
  });
};

/* harmony default export */ var Post_Post = (Post);
;// CONCATENATED MODULE: ./src/modules/Post/index.ts

;// CONCATENATED MODULE: ./src/pages/blog/[post].tsx


function _post_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _post_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { _post_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { _post_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }














const PostPage = props => {
  var _post$data, _post$data2, _ref, _post$data$openGraphI, _post$data3, _post$data3$openGraph, _post$data4, _post$data4$image, _post$data4$image$ope;

  const router = (0,next_router.useRouter)();
  const currentPath = (0,common/* getCurrentPath */.b$)(router);
  const canonicalUrl = "https://dverione.com.ua" + currentPath;

  if (props.pageType === 'Error') {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(_error["default"], _post_objectSpread({}, (0,common/* convertErrorToProps */.g1)(props.error)));
  }

  if (props.pageType === 'NOT_FOUND') {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(_404["default"], {});
  }

  const {
    post
  } = props;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(web_components_esm/* Page */.T3, {
    title: post === null || post === void 0 ? void 0 : (_post$data = post.data) === null || _post$data === void 0 ? void 0 : _post$data.pageTitle,
    description: post === null || post === void 0 ? void 0 : (_post$data2 = post.data) === null || _post$data2 === void 0 ? void 0 : _post$data2.pageDescription,
    openGraphImage: (_ref = (_post$data$openGraphI = post === null || post === void 0 ? void 0 : (_post$data3 = post.data) === null || _post$data3 === void 0 ? void 0 : (_post$data3$openGraph = _post$data3.openGraphImage) === null || _post$data3$openGraph === void 0 ? void 0 : _post$data3$openGraph.url) !== null && _post$data$openGraphI !== void 0 ? _post$data$openGraphI : post === null || post === void 0 ? void 0 : (_post$data4 = post.data) === null || _post$data4 === void 0 ? void 0 : (_post$data4$image = _post$data4.image) === null || _post$data4$image === void 0 ? void 0 : (_post$data4$image$ope = _post$data4$image.openGraph) === null || _post$data4$image$ope === void 0 ? void 0 : _post$data4$image$ope.url) !== null && _ref !== void 0 ? _ref : '',
    canonicalUrl: canonicalUrl,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Post_Post, {
        post: post.data
      })
    })
  });
};

/* harmony default export */ var _post_ = (PostPage);

PostPage.getInitialProps = async context => {
  const {
    store,
    query,
    res
  } = context;
  const path = (0,helpers/* getCurrentAliasPage */.T)((0,common/* convertSlugToPath */.L1)(query.post));

  try {
    var _foundPost$data;

    const requests = Promise.all([...(0,thunks/* getSharedThunkList */.q)(store.dispatch), store.dispatch((0,blog/* getBlogPostByAliasThunk */.xZ)(path))]);
    await requests;
    const foundPost = (0,blog/* selectBlogPostByAliasResource */.a)(store.getState(), path);

    if (!(foundPost !== null && foundPost !== void 0 && (_foundPost$data = foundPost.data) !== null && _foundPost$data !== void 0 && _foundPost$data.id)) {
      if (res) {
        res.statusCode = 404;
      }

      return {
        pageType: 'NOT_FOUND'
      };
    }

    return {
      pageType: 'Post',
      post: foundPost
    };
  } catch (error) {
    return {
      pageType: 'Error',
      error
    };
  }
};

/***/ }),

/***/ 26625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ getSharedThunkList; }
/* harmony export */ });
/* harmony import */ var _store_reducers_tager_menus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67463);
/* harmony import */ var _store_reducers_tager_settings__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35439);
/* harmony import */ var _store_reducers_pages_products__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13006);
/* harmony import */ var _store_reducers_tager_blog__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44272);




function getSharedThunkList(dispatch) {
  return [dispatch((0,_store_reducers_tager_menus__WEBPACK_IMPORTED_MODULE_0__/* .getMenuItemListThunk */ .up)('top')), dispatch((0,_store_reducers_tager_menus__WEBPACK_IMPORTED_MODULE_0__/* .getMenuItemListThunk */ .up)('main')), dispatch((0,_store_reducers_tager_menus__WEBPACK_IMPORTED_MODULE_0__/* .getMenuItemListThunk */ .up)('footer')), dispatch((0,_store_reducers_tager_menus__WEBPACK_IMPORTED_MODULE_0__/* .getMenuItemListThunk */ .up)('catalog')), dispatch((0,_store_reducers_pages_products__WEBPACK_IMPORTED_MODULE_2__/* .getProductListByGroupThunk */ .fd)('TOP')), dispatch((0,_store_reducers_pages_products__WEBPACK_IMPORTED_MODULE_2__/* .getProductListByGroupThunk */ .fd)('NEW')), dispatch((0,_store_reducers_tager_settings__WEBPACK_IMPORTED_MODULE_1__/* .getSettingItemListThunk */ .rT)()), dispatch((0,_store_reducers_tager_menus__WEBPACK_IMPORTED_MODULE_0__/* .getCatalogMenuThunk */ .ke)()), dispatch((0,_store_reducers_tager_blog__WEBPACK_IMPORTED_MODULE_3__/* .getBlogPostListThunk */ .R3)())];
}

/***/ }),

/***/ 10977:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[post]",
      function () {
        return __webpack_require__(82296);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [741,989,880,774,888,179], function() { return __webpack_exec__(10977); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);